<template>
  <my-profile-menu-layout>
    <api-tokens></api-tokens>
  </my-profile-menu-layout>
</template>

<script>
import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
import ApiTokens from "@/components/myprofile/ApiTokens";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";

export default {
  name: "ProfileApiTokens",
  components: { MyProfileMenuLayout, ApiTokens },
  mixins: [CurrentUserMixin],
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    // Profile pages don't need a project context
  },
}
</script>

<style scoped>

</style>
